export class InvoicePageList {
    id: number;
    description: string;
    qty: number;
    category: string;
    amount: number;
}
